import FormViewForm from '@src/components/_forms/FormViewForm';
import {IClientModel} from '@src/@interfaces/models/Client/IClientModel';
import ClientContactsField from './fields/ClientContactsField';

const customFields = {
    contacts: {
        component: ClientContactsField,
    },
};

export default class ContractorForm<Model extends IClientModel> extends FormViewForm<Model> {
    protected get customFields() {
        return customFields;
    }

    protected mutateModelFieldInitialValue(fieldName: string, modelValue: any): any {
        if (fieldName === 'contacts') {
            return this.getContractsFieldInitialValue();
        }

        return super.mutateModelFieldInitialValue(fieldName, modelValue);
    }

    private getContractsFieldInitialValue() {
        return this.props.model?.contacts?.map(contact => ({
            id: contact.id,
            type: contact.type,
            value: contact.value,
        }));
    }
}
